import PromptsCard from "component/promptsCard/PromptsCard";
import React, { useEffect } from "react";
import clockHistoryIcon from "../../assets/photos/clock-history-icon.svg";
import { Globalstate } from "context/context";
import "./prompts.css";

const Prompts = ({ isFocused, lastFiveSearches, handleSubmit }) => {
  const { state } = Globalstate();

  return (
    <div className="prompts-conp">
      {isFocused && lastFiveSearches?.length > 0 ? (
        <div className="previous-searches">
          <div className="header">Your recent searches</div>
          <div className="searches">
            {lastFiveSearches.map((item, i) => {
              return (
                <div
                  className="searches-item"
                  key={i}
                  onClick={() => handleSubmit(item)}
                >
                  <img src={clockHistoryIcon} alt="" />
                  <p>{item}</p>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <>
          <div className="heading">
            <p>Don’t know what to ask??</p>
            <hr />
            <span>Try one of these...</span>
          </div>
          <div className="prompts-container">
            {state?.prompts?.length > 0 &&
              state?.prompts?.slice(0, 3).map((item, index) => {
                return (
                  <PromptsCard
                    imgLink={item?.image_url}
                    text={item?.text}
                    key={index}
                  />
                );
              })}
          </div>
        </>
      )}
    </div>
  );
};

export default Prompts;
